import React, { useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { currentAddressSameMedavieAction, setCurrentAddressMedavieDifferentProperty } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { validateApartmentErrors, validateCityErrors, validatePostalCodeErrors, validateStreetAddressErrors } from "../../../../shared/helpers/validators";
import StreetAddress from 'shared/components/Address/StreetAddress'
import Apartment from 'shared/components/Address/Apartment'
import City from 'shared/components/Address/City'
import PostalCode from 'shared/components/Address/PostalCode'
import AddressAutofill from '../../../../shared/components/Address/AddressAutofill';

const CURRENT_ADDRESS_MEDAVIE_DIFFERENT = "currentAddress.medavieDifferentAddress";

const MedavieQuestion = ({ t, i18n, setIsError, medavieAddressErrors, setMedavieAddressErrors }) => {
  const dispatch = useDispatch()

  const handleRadioChange = (isSame) => () => {
    dispatch(currentAddressSameMedavieAction(isSame))
  }

  const { currentAddressSameMedavie } = useSelector((state) => state.app.currentAddress)

  const validateStreetAddress = (name) => {
    const newMedavieErrors = { ...medavieAddressErrors }
    newMedavieErrors.streetAddress = validateStreetAddressErrors(name);
    setMedavieAddressErrors(newMedavieErrors);

  }

  const validateApartment = (name) => {
    const newMedavieErrors = { ...medavieAddressErrors }
    newMedavieErrors.apartment = validateApartmentErrors(name);
    setMedavieAddressErrors(newMedavieErrors);
  }

  const validateCity = (cityName) => {
    try {
      const newMedavieErrors = { ...medavieAddressErrors }
      newMedavieErrors.city = validateCityErrors(cityName);
      setMedavieAddressErrors(newMedavieErrors);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePostalCode = (number) => {
    try {
      const newMedavieErrors = { ...medavieAddressErrors }
      newMedavieErrors.postalCode = validatePostalCodeErrors(number);
      setMedavieAddressErrors(newMedavieErrors);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const handleChangeObjectPropertyAction = useCallback((fieldName, value) => {
    dispatch(setCurrentAddressMedavieDifferentProperty(fieldName, value));
  }, [dispatch]);

  return (
    <div className="container">
      <main>
        <article>
          <div className="row">
            <div className="col-xs-12">
              <h2>{t('current_address.current_home_address_medavie')}</h2>
              <div className='ns-radios__item'>
                <input className="ns-radios__input" type="radio" id="SameAddress" value="SameAddress" onChange={handleRadioChange(true)}
                  checked={currentAddressSameMedavie} />
                <label className="ns-label ns-radios__label" htmlFor="SameAddress" key="SameAddress" >
                  <span className="ns-label-span">{t('current_address.same_as_registry_of')} </span>
                </label>
              </div>
              <div className='ns-radios__item'>
                <input className="ns-radios__input" type="radio" id="DifferentAddress" value="DifferentAddress" onChange={handleRadioChange(false)}
                  checked={currentAddressSameMedavie === false} />
                <label className="ns-label ns-radios__label" htmlFor="DifferentAddress" key="DifferentAddress" >
                  <span className="ns-label-span">{t('current_address.different_than_registry_of')} </span>
                </label>
              </div>
            </div>
          </div>

          {!currentAddressSameMedavie && (
            <div className="row">
              <div className="col-xs-12">
                <AddressAutofill
                  validateStreetAddress={validateStreetAddress}
                  streetAddressError={medavieAddressErrors.streetAddress}
                  streetAddressValid={medavieAddressErrors.streetAddress === '' ? '' : !medavieAddressErrors.streetAddress}
                  setIsError={setIsError}
                  reduxAppProperty={CURRENT_ADDRESS_MEDAVIE_DIFFERENT}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  validateApartment={validateApartment}
                  apartmentError={medavieAddressErrors.apartment}
                  apartmentValid={medavieAddressErrors.apartment === '' ? '' : !medavieAddressErrors.apartment}
                  validateCity={validateCity}
                  cityError={medavieAddressErrors.city}
                  cityValid={medavieAddressErrors.city === '' ? '' : !medavieAddressErrors.city}
                  validatePostalCode={validatePostalCode}
                  postalCodeError={medavieAddressErrors.postalCode}
                  postalCodeValid={medavieAddressErrors.postalCode === '' ? '' : !medavieAddressErrors.postalCode}
                />
                {/* <StreetAddress
                  validateStreetAddress={validateStreetAddress}
                  streetAddressError={medavieAddressErrors.streetAddress}
                  streetAddressValid={medavieAddressErrors.streetAddress === '' ? '' : !medavieAddressErrors.streetAddress}
                  setIsError={setIsError}
                  reduxAppProperty={CURRENT_ADDRESS_MEDAVIE_DIFFERENT}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                />
                <Apartment
                  validateApartment={validateApartment}
                  apartmentError={medavieAddressErrors.apartment}
                  apartmentValid={medavieAddressErrors.apartment === '' ? '' : !medavieAddressErrors.apartment}
                  setIsError={setIsError}
                  reduxAppProperty={CURRENT_ADDRESS_MEDAVIE_DIFFERENT}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                />
                <City
                  validateCity={validateCity}
                  validatePostalCode={validatePostalCode}
                  cityError={medavieAddressErrors.city}
                  cityValid={medavieAddressErrors.city === '' ? '' : !medavieAddressErrors.city}
                  setIsError={setIsError}
                  reduxAppProperty={CURRENT_ADDRESS_MEDAVIE_DIFFERENT}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                />
                <PostalCode
                  validatePostalCode={validatePostalCode}
                  postalCodeError={medavieAddressErrors.postalCode}
                  postalCodeValid={medavieAddressErrors.postalCode === '' ? '' : !medavieAddressErrors.postalCode}
                  setIsError={setIsError}
                  reduxAppProperty={CURRENT_ADDRESS_MEDAVIE_DIFFERENT}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                /> */}
              </div>
            </div>
          )}
        </article>
      </main >
    </div >
  )
}

export default withTranslation('common')(MedavieQuestion)
